var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDashboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 33",
    style: {
      fill: "none"
    },
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 276"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 25",
    d: "M11.868 12.916H7.046A1.047 1.047 0 0 1 6 11.869V7.047A1.047 1.047 0 0 1 7.046 6h4.822a1.047 1.047 0 0 1 1.047 1.047v4.822a1.047 1.047 0 0 1-1.047 1.047",
    transform: "translate(-3.486 -3.589)",
    style: {
      fill: "current"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 26",
    d: "M31.355 12.916h-4.822a1.047 1.047 0 0 1-1.047-1.047V7.047A1.047 1.047 0 0 1 26.533 6h4.822A1.047 1.047 0 0 1 32.4 7.047v4.822a1.047 1.047 0 0 1-1.047 1.047",
    transform: "translate(-14.813 -3.589)",
    style: {
      fill: "current"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 27",
    d: "M11.868 32.416H7.046A1.047 1.047 0 0 1 6 31.369v-4.822A1.047 1.047 0 0 1 7.046 25.5h4.822a1.047 1.047 0 0 1 1.047 1.047v4.822a1.047 1.047 0 0 1-1.047 1.047",
    transform: "translate(-3.486 -14.923)",
    style: {
      fill: "current"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 28",
    d: "M31.355 32.416h-4.822a1.047 1.047 0 0 1-1.047-1.047v-4.822a1.047 1.047 0 0 1 1.047-1.047h4.822a1.047 1.047 0 0 1 1.045 1.047v4.822a1.047 1.047 0 0 1-1.047 1.047",
    transform: "translate(-14.813 -14.923)",
    style: {
      fill: "current"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDashboard);
export default __webpack_public_path__ + "static/media/icon_dashboard.dfabc0a0811c23d210888fe0a43de3be.svg";
export { ForwardRef as ReactComponent };